import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dataFetcher from "../../parts/chore/dataFetcher";
import { fetchBlockedUsers, unblockUser } from "../../messages/messageActions";

import BlockedUsers from './BlockedUsers';

const mapStateToProps = state => ({
  blockedUsers: state.message.blockedUsers
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchBlockedUsers,
  unblockUser
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(BlockedUsers);